$ = require 'jquery'
Controller = require 'app/scripts/controller'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'

{ TeamlessCollaborationPrompt } = require 'app/src/components/TeamlessCollaborationPrompt'
{ featureFlagClient } = require '@trello/feature-flag-client'
Auth = require 'app/scripts/db/auth'
{ renderComponent } = require 'app/src/components/ComponentWrapper'

module.exports.onTeamCreatedFromCollaborationPrompt = (orgName) ->
  Controller.organizationBoardsView(orgName, { shouldShowTeamfulCollaborationPrompt: true })
    .then(=> @unmountTeamlessCollaborationPrompt())

module.exports.unmountTeamlessCollaborationPrompt = ->
  if @teamlessCollaborationPromptDiv?
    ReactDOM.unmountComponentAtNode(@teamlessCollaborationPromptDiv)

  # We want to make sure that we aren't displaying
  # the invite acceptance popover at the same time
  @isPopoverRendered = false

module.exports.renderTeamlessCollaborationPrompt = ->
  if !@teamlessCollaborationPromptDiv?
    targetDiv = $("#teamless-collaboration-prompt-target")[0]

    if targetDiv?
      @teamlessCollaborationPromptDiv = targetDiv
    else
      $('#surface').append("<div id='teamless-collaboration-prompt-target'></div>")
      @teamlessCollaborationPromptDiv = $("#teamless-collaboration-prompt-target")[0]

    @teamlessCollaborationPromptComponent = React.createElement(
      TeamlessCollaborationPrompt,
      {
        boardId: @model.id,
        onClose: => @unmountTeamlessCollaborationPrompt(),
        onTeamCreated: (orgName) => @onTeamCreatedFromCollaborationPrompt(orgName),
        target: => @$('.js-add-board-to-team')[0]
      }
    )

  if !featureFlagClient.get('bizteam.teamless_collaboration_prompt', false) || \
   Auth.me().isDismissed("TeamlessCollaborationPrompt-#{@model.id}")
    return

  @teamlessCollaborationPromptHasBeenSeen = true
  renderComponent(
    @teamlessCollaborationPromptComponent,
    @teamlessCollaborationPromptDiv
  )
